module.exports = __webpack_public_path__ + "images/fast_ferries/map.png";